<template>
    <span>{{pad}}</span>
</template>

<script>
export default {
    name: 'ZeroPad',
    data: function() {
        return {
        }
    },
    computed: {
        pad() {
            let v = new String(this.value)
            while(v.length < this.length)
                v = '0'+v
            return v
        }
    },
    props: {value: Number, length:Number}
}
</script>

<style>

</style>
